<template>
  <div class="heart-effect">
    <md-field>
      <!-- Multiple heart sound spots might become relevant later when we do cardiac cases -->
      <!-- <md-select
        class="spot-select"
        :value="state.effect.spot"
        @input="spot => selectSpot(spot)"
        placeholder="all spots"
        :disabled="readonly"
      >
        <md-option
          class="spot-option"
        >All</md-option>
        <md-option
          v-for="spot in heartSoundSpots"
          :key="spot"
          :value="spot"
          class="spot-option"
        >{{ spot + 1 }}</md-option>
      </md-select> -->
      <div class="sound-volume-container">
        <md-field>
          <md-select
            v-close-on-zoom
            :value="state.effect.value"
            placeholder="Sound"
            class="heart-sound-select"
            :disabled="readonly"
            @input="heartSound => updateSound(heartSound)"
          >
            <md-option
              v-for="heartSound in heartSounds"
              :key="heartSound.id"
              :value="heartSound.resourceName"
            >
              {{ heartSound.resourceName.replace(/_/g, ' ').replace(/\..+/, '') | startCase }}
            </md-option>
          </md-select>
        </md-field>
        <!-- The event is to prevent volume slider from moving the node with it -->
        <volume-slider
          :value="!isUndefined(state.effect.volume) ? state.effect.volume : 1"
          @pointerdown.native.stop
          @input="updateVolume"
        />
      </div>
    </md-field>
  </div>
</template>

<script>
import startCase from 'lodash/startCase';
import isUndefined from 'lodash/isUndefined';

import VolumeSlider from '~lib/common/components/VolumeSlider';

export default {
  name: 'heart-effect',
  filters: {
    startCase,
  },
  components: {
    VolumeSlider,
  },
  props: ['sounds', 'readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {},
      },
      heartSounds: this.sounds.filter(s => s.category === 'heart'),
      // Multiple heart sound spots might become relevant later when we do cardiac cases
      // heartSoundSpots: [0, 1, 2, 3, 4],
    };
  },
  computed: {
  },
  mounted() {
    this.state.effect = this.getData(this.ikey) || {};
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateSound(heartSoundKey) {
      this.state.effect.value = heartSoundKey;
      this.update();
    },
    updateVolume(volume) {
      this.state.effect.volume = volume;
      this.update();
    },
    // Multiple heart sound spots might become relevant later when we do cardiac cases
    // selectSpot(spot) {
    //   this.state.effect.spot = spot;
    //   this.update();
    // },
    update() {
      this.putData(this.ikey, { type: 'HEART_SOUND', spot: 0, ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
    isUndefined,
  },
};
</script>

<style scoped>
.heart-effect {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.md-field {
  align-items: flex-start;
}

.duration-input {
  width: 125px;
}
.sound-volume-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.volume-slider {
  width: 120px;
  margin-right: 10px;
  align-self: flex-end;
}
</style>
